// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34w-4","type":"styles_type__256jD","choices":"styles_choices__3EdmX"};